"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Pagination = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paginationModule = _interopRequireDefault(require("./pagination.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Pagination = exports.Pagination = /*#__PURE__*/function (_Component) {
  function Pagination(props) {
    var _this;
    _classCallCheck(this, Pagination);
    _this = _callSuper(this, Pagination, [props]);
    _this.state = {
      page: _this.props.page
    };
    return _this;
  }
  _inherits(Pagination, _Component);
  return _createClass(Pagination, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.page !== this.props.page) {
        this.setPage(this.props.page);
      }
    }
  }, {
    key: "setPage",
    value: function setPage(page) {
      this.setState({
        page: page
      });
    }
  }, {
    key: "getTotalPages",
    value: function getTotalPages() {
      var pages = Math.ceil(this.props.records / this.props.recordsPerPage);
      if (pages < 1) pages = 1;
      return pages;
    }
  }, {
    key: "getPageClassName",
    value: function getPageClassName(page) {
      var currentPage = this.getCurrentPage();
      if (currentPage === page) {
        return "".concat(_paginationModule["default"].page, " ").concat(_paginationModule["default"].currentPage);
      }
      if (page === "...") {
        return "".concat(_paginationModule["default"].page, " ").concat(_paginationModule["default"].disabled);
      }
      return _paginationModule["default"].page;
    }
  }, {
    key: "getDataTestId",
    value: function getDataTestId(page) {
      var currentPage = this.getCurrentPage();
      if (currentPage === page) {
        return "currentPage";
      }
      return "page";
    }
  }, {
    key: "getPages",
    value: function getPages() {
      if (this.props.maxVisiblePages) {
        return this.getPageRageWithDots();
      } else {
        return this.getPageRange();
      }
    }
  }, {
    key: "getCurrentPage",
    value: function getCurrentPage() {
      if (this.state.page < 1) {
        return 1;
      }
      if (this.state.page > this.getTotalPages()) {
        return this.getTotalPages();
      }
      return this.state.page;
    }
  }, {
    key: "getMaxPages",
    value: function getMaxPages() {
      if (this.props.maxVisiblePages < 5) {
        return 5;
      }
      if (this.isOdd(this.props.maxVisiblePages)) {
        return this.props.maxVisiblePages;
      }
      return this.props.maxVisiblePages - 1;
    }
  }, {
    key: "getVisibleBlock",
    value: function getVisibleBlock() {
      var totalCount = this.getTotalPages();
      var maxPages = this.getMaxPages();
      var currentPage = this.getCurrentPage();
      var visibleBlock = Math.round(maxPages - 4);
      var range = Math.ceil(visibleBlock / 2);
      var blockStart = currentPage - range;
      var blockEnd = currentPage + range;
      var difference = blockEnd - blockStart;
      if (currentPage <= range + 1) {
        blockStart = 1;
        blockEnd = blockStart + difference;
      } else if (currentPage >= totalCount - range) {
        blockEnd = totalCount;
        blockStart = blockEnd - difference;
      } else {
        blockStart = currentPage - range + 1;
        blockEnd = currentPage + (currentPage - blockStart);
      }
      return {
        blockStart: blockStart,
        blockEnd: blockEnd
      };
    }
  }, {
    key: "isOdd",
    value: function isOdd(num) {
      return num % 2;
    }
  }, {
    key: "shouldHide",
    value: function shouldHide() {
      return this.getTotalPages() <= 1 && this.props.hide;
    }
  }, {
    key: "getPageRageWithDots",
    value: function getPageRageWithDots() {
      if (this.shouldHide()) {
        return [];
      }
      var range = [];
      var totalCount = this.getTotalPages();
      var _this$getVisibleBlock = this.getVisibleBlock(),
        blockStart = _this$getVisibleBlock.blockStart,
        blockEnd = _this$getVisibleBlock.blockEnd;
      for (var i = 1; i <= totalCount; i++) {
        if (i === 1 || i === totalCount) {
          range.push(i);
        } else if (i === 2 && blockStart > 2 || i === totalCount - 1 && blockEnd < totalCount - 1) {
          range.push("...");
        } else {
          if (i >= blockStart && i <= blockEnd) {
            range.push(i);
          }
        }
      }
      return range;
    }
  }, {
    key: "getPageRange",
    value: function getPageRange() {
      if (this.shouldHide()) {
        return [];
      }
      var range = [];
      var totalCount = this.getTotalPages();
      for (var i = 1; i <= totalCount; i++) {
        range.push(i);
      }
      return range;
    }
  }, {
    key: "selectPage",
    value: function selectPage(page) {
      var currentPage = this.getCurrentPage();
      if (this.props.onSelectPage && currentPage !== page && page !== "...") {
        this.props.onSelectPage(page);
        this.setPage(page);
      }
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var _this2 = this;
      return this.getPages().map(function (page, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "".concat(page, "-").concat(index),
          className: _this2.getPageClassName(page),
          "data-testid": _this2.getDataTestId(page),
          onClick: function onClick() {
            return _this2.selectPage(page);
          }
        }, page);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _paginationModule["default"].pagination,
        style: this.props.style,
        "data-testid": "pagination"
      }, this.renderPages());
    }
  }]);
}(_react.Component);
Pagination.propTypes = {
  page: _propTypes["default"].number,
  records: _propTypes["default"].number,
  recordsPerPage: _propTypes["default"].number,
  maxVisiblePages: _propTypes["default"].number,
  onSelectPage: _propTypes["default"].func,
  hide: _propTypes["default"].bool
};
Pagination.defaultProps = {
  page: 1,
  records: 0,
  recordsPerPage: 20,
  maxVisiblePages: null,
  onSelectPage: null,
  hide: false
};
var _default = exports["default"] = Pagination;